import { render } from "./ContentNavigation.vue?vue&type=template&id=b9c57aac&ts=true"
import script from "./ContentNavigation.vue?vue&type=script&lang=ts"
export * from "./ContentNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__